import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import moment from "moment";
import {
  Button,
  ButtonIcon,
  InfoRowView,
  OfferCard,
  OfferCardSmall,
  RadioBox,
  SelectBox,
  Tag,
} from "../..";
import * as actionTypes from "../../../store/actions/types";
import { connect, useDispatch, useSelector } from "react-redux";
import { GetIcon } from "../../../config/icon";
import { FiCopy } from "react-icons/fi";
import { Tabs } from "antd";
import { OpenNotification } from "../../../config/notification";
import {
  cooGetMerchantOfferCount,
  cooGetOfferByMerchant,
} from "../../../containers/merchant/service/merchant.service";
import { RiCheckLine } from "react-icons/ri";

const Index = (props) => {
  const [isExpand, setIsExpand] = useState(false);
  const [offers, setOffers] = useState([]);
  const [noOfOffers, setNoOfOffers] = useState(0);
  const [isLoadingNoOfOffer, setIsLoadingNoOfOffer] = useState(false);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const { bankData } = useSelector(({ bankReducer }) => bankReducer);
  const { isSelectedExistingTerms } = useSelector(
    ({ termsReducer }) => termsReducer
  );

  const dispatch = useDispatch();

  const handleToggleExpand = async () => {
    setIsExpand(!isExpand);
    setIsLoadingNoOfOffer(true);
    let res = await cooGetMerchantOfferCount(props?.merchantId);
    setSelectedBankId(Number(res?.data?.data[0]?.totalCount));
    await onLoadMerchantOffers();
    setIsLoadingNoOfOffer(true);
  };

  const loadOfferCount = async () => {
    setIsLoadingNoOfOffer(true);
    let res = await cooGetMerchantOfferCount(props?.merchantId);

    setSelectedBankId(res?.data?.data?.[0]?.totalCount || 0);
    setIsLoadingNoOfOffer(false);
  };

  useEffect(() => {
    if (props?.merchantId) {
      // loadOfferCount();
    } else {
      setNoOfOffers(0);
      setIsLoadingNoOfOffer(false);
    }
  }, []);
  const { TabPane } = Tabs;

  const onLoadMerchantOffers = async () => {
    let resOfferByMerchant = await cooGetOfferByMerchant(props?.merchantId);
    if (resOfferByMerchant?.data?.data) {
      setOffers(resOfferByMerchant?.data?.data);
    }
  };

  return (
    <>
      <div
        className={`cco__merchant-card-extraSmall__wrapper d-flex flex-row justify-content-between align-items-center ${
          props.isActive || props.isSelect ? "isActive" : ""
        }`}
      >
        <div className={"d-flex flex-row align-items-center"}>
          <div className={"cco__mcew__logo"}>
            <img src={props.logo} alt="creditcard offers" />
          </div>

          <div
            className={"d-flex flex-column justify-content-center"}
            style={{ paddingLeft: "5px" }}
          >
            <div className={"cco__mcew__name"}>
              {props.merchantName}
              {/* {" (" + noOfOffers + ")"} */}
            </div>

            <div className={"cco__mcew__id d-flex flex-row align-items-center"}>
              {props.merchantId}
              <div className={"cco__mcew__copy"}>
                <FiCopy />
              </div>
            </div>
          </div>
        </div>
        <div className={"d-flex flex-row"}>
          <ButtonIcon
            onClick={handleToggleExpand}
            buttonIcon={GetIcon(isExpand ? "arrowUp" : "arrowDown")}
            type={"collapse-icon"}
            size={"sm"}
          />

          <div
            className={`cco__mcew__checkbox  ${
              props.isSelect ? "is_active" : ""
            } `}
            onClick={props.onClick}
          >
            {props.isSelect && (
              <>
                <RiCheckLine />
              </>
            )}
          </div>
        </div>
      </div>
      {isExpand && (
        <div className="expanded-content">
          {offers && offers.length > 0 && (
            <>
              {((offers && offers) || []).map((item, index) => (
                <OfferCardSmall
                  offerId={item && item?.offerId}
                  details={item && item?.header}
                  termsAndCondition={item && item?.termsConditions}
                  name={item && item.merchant && item.merchant?.merchantName}
                  bankName={item && item.bank && item.bank?.bankName}
                  logo={item && item?.bank && item?.bank?.logoURL}
                  imgUrl={item.bannerImageURL}
                  userName={item && item?.user?.firstName}
                  categoryName={item && item?.category?.categoryName}
                  createAt={item && item.createdAt}
                  type={"view"}
                  size={"sm"}
                  isCollapse={true}
                  status={
                    item &&
                    item?.status?.charAt(0).toUpperCase() +
                      item?.status?.slice(1)
                  }
                />
              ))}
            </>
          )}
        </div>
      )}
    </>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
};

Index.defaultProps = {
  title: "",
};

const mapStateToProps = (state) => {
  return {
    isOpenSearchMerchant: state.merchantReducer.isOpenSearchMerchant,
    selectMerchant: state.merchantReducer.selectMerchant,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClickSelectedOffer: (payload) =>
      dispatch({ type: actionTypes.SELECTED_SEARCH_MERCHANT_MODAL, payload }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
